<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      ref="dataTable"
      @selection-change="selectionChange"
      stripe
      :border="borderable"
      :size="sizeable"
      :height="height"
    >
      <el-table-column
        v-if="selectable"
        class-name="drag-disable"
        type="selection"
        :selectable="checkSelectable"
        width="40"
      ></el-table-column>
      <el-table-column
        :label="item.label"
        :prop="item.prop"
        :sortable="item.sort"
        :show-overflow-tooltip="item.showTip == true ? true : false"
        :min-width="item.minWidth"
        :width="item.width"
        v-for="item in tableColumns"
        :key="item.prop"
      >
      </el-table-column>
      <slot></slot>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    data: { type: Array, required: true },
    columns: { type: Array, required: true },
    borderable: { type: Boolean, default: false },
    selectable: { type: Boolean, default: true },
    sizeable: { type: String, default: 'medium' },
    height: { type: Number|String, default: null},
  },
  data() {
    return {
      tableColumns: [],
    };
  },
  methods: {
    refresh() {
      this.$forceUpdate();
      this.$refs.dataTable.doLayout();
    },
    getKey(item) {
      //为支持列排序，每次产生一个唯一key，防止缓存造成排序失败
      return Number(
        Math.random().toString().substr(3, 10) + Date.now()
      ).toString(36);
    },
    selectionChange(selects) {
      //表格选择事件
      this.$emit("selects", selects);
    },
    rowClick(row) {
      //表格单击事件
      this.$refs.dataTable.toggleRowSelection(row);
    },
    checkSelectable(row, index) {
      if (row.selectable == false) {
        return false;
      } else {
        return true;
      }
    },
    resetColumns() {
      let tempArr = [];
      this.columns.forEach((obj) => {
        let tempObj = {};
        for (let attr in obj) {
          tempObj[attr] = obj[attr];
        }
        tempArr.push(tempObj);
      });
      this.tableColumns = tempArr;
      tempArr = null;
    },
  },
  created() {
    this.resetColumns();
  },
};
</script>
<style lang="scss" scoped>
.table-wrapper {
  position: relative;
  .table-option {
    position: absolute;
    right: 20px;
    top: -28px;
    .conf-button {
      color: #e6a23c;
      font-weight: bold;
    }
  }
}
.column-options {
  margin-top: 5px;
  &:first-of-type {
    margin-top: 0;
  }
}
.column-reset {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.colorRed {
  color: #f56c6c;
}
</style>


